var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.46391 23.5432C7.84536 22.9342 7.84536 21.9467 8.46391 21.3377L21.1569 8.83964C21.7755 8.2306 22.7783 8.2306 23.3969 8.83964C24.0154 9.44868 24.0154 10.4361 23.3969 11.0452L10.7039 23.5432C10.0853 24.1523 9.08245 24.1523 8.46391 23.5432Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.60313 8.45678C9.22168 7.84774 10.2245 7.84774 10.8431 8.45678L23.5361 20.9548C24.1546 21.5639 24.1546 22.5513 23.5361 23.1604C22.9175 23.7694 21.9147 23.7694 21.2961 23.1604L8.60313 10.6623C7.98459 10.0533 7.98459 9.06582 8.60313 8.45678Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame4);
export default __webpack_public_path__ + "static/media/Frame 4.74c202e24faf81ff3edcd7aa132330a0.svg";
export { ForwardRef as ReactComponent };